import { WORKFLOW_IMPORT_DIALOG_SET_OPEN } from 'actions/workflowImport';

function getInitialState() {
  return {
    workflowImportDialogIsOpen: false,
  };
}

export default function workflowImportReducer(
  state = getInitialState(),
  action,
) {
  switch (action.type) {
    case WORKFLOW_IMPORT_DIALOG_SET_OPEN: {
      return {
        ...state,
        workflowImportDialogIsOpen: action.payload.isOpen,
      };
    }
    default:
      return state;
  }
}
